import Navbar from "../blocks/navbar";
import BreadcrumbPage from "../blocks/breadcrumb";
import Footer from "../blocks/footer";
import * as React from "react";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import ReactPaginate from "react-paginate";
import {connect} from "react-redux";
import {getAllProducts, getProductCategories} from "../store/productGallery";
import SimpleReactLightbox, {SRLWrapper} from "simple-react-lightbox";

function ProductGallery(props) {
    const {t, i18n} = useTranslation();
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState('');

    // Ma'lumotlarni yuklash
    useEffect(() => {
        props.getProductCategories();
        props.getAllProducts();
    }, []);

    // Props o'zgarganda state yangilash
    useEffect(() => {
        setProducts(props.products);
    }, [props.products]);

    useEffect(() => {
        setCategories(props.categories);
    }, [props.categories]);

    // Kategoriya bo'yicha filter
    function handleCategoryFilter(categoryId) {
        setActiveCategory(categoryId);
        setItemOffset(0);
        props.getAllProducts(categoryId);
    }

    // Pagination
    const [itemsPerPage] = useState(12);
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = products.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(products.length / itemsPerPage);

    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % products.length;
        setItemOffset(newOffset);
        window.scrollTo(0, 0);
    };

    const lightboxOptions = {
        thumbnails: {showThumbnails: false},
        buttons: {showDownloadButton: false},
    };

    return (
        <div>
            <Navbar/>
            <BreadcrumbPage props={'product_gallery'}/>
            <div className={'page'}>
                <div className="container">
                    <h2>{t('product_gallery')}</h2>

                    {/* Kategoriya filterlari */}
                    <div className={'category-filter'} style={{marginBottom: '24px'}}>
                        <ul className={'news-filter'} style={{display: 'flex', flexWrap: 'wrap', gap: '8px', listStyle: 'none', padding: 0}}>
                            <li
                                onClick={() => handleCategoryFilter('')}
                                className={activeCategory === '' ? 'active' : ''}
                                style={{cursor: 'pointer'}}
                            >
                                {t('all')}
                            </li>
                            {categories.map((cat, index) => (
                                <li
                                    key={index}
                                    onClick={() => handleCategoryFilter(cat.id)}
                                    className={activeCategory === cat.id ? 'active' : ''}
                                    style={{cursor: 'pointer'}}
                                >
                                    {cat[`title_${i18n.language}`] || cat.title}
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Rasm galereyasi */}
                    <SimpleReactLightbox>
                        <SRLWrapper options={lightboxOptions}>
                            <div className={'gallery-block'}>
                                <div className="row">
                                    {currentItems.length ? currentItems.map((item, index) => (
                                        <div className={'col-lg-3 col-md-4 col-6'} key={index} style={{marginBottom: '20px'}}>
                                            <a href={item.image}>
                                                <img
                                                    src={item.image}
                                                    alt={item[`title_${i18n.language}`] || item.title}
                                                    style={{
                                                        width: '100%',
                                                        height: '200px',
                                                        objectFit: 'cover',
                                                        borderRadius: '8px',
                                                        cursor: 'pointer'
                                                    }}
                                                />
                                            </a>
                                            <p style={{
                                                marginTop: '8px',
                                                fontSize: '13px',
                                                color: '#555',
                                                textAlign: 'center'
                                            }}>
                                                {item[`title_${i18n.language}`] || item.title}
                                            </p>
                                        </div>
                                    )) : (
                                        <div className={'col-12 text-center'} style={{padding: '40px 0', color: '#999'}}>
                                            {t('notFound')}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </SRLWrapper>
                    </SimpleReactLightbox>

                    {/* Pagination */}
                    {pageCount > 1 && (
                        <div className={'pagination-news'}>
                            <ReactPaginate
                                breakLabel="..."
                                nextLabel=">"
                                onPageChange={handlePageClick}
                                pageRangeDisplayed={5}
                                pageCount={pageCount}
                                previousLabel="<"
                                renderOnZeroPageCount={null}
                            />
                        </div>
                    )}
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default connect(
    ({product_gallery: {products, categories}}) => ({products, categories}),
    {getAllProducts, getProductCategories}
)(ProductGallery);
